import { AbstractControl, ValidationErrors } from '@angular/forms';

export class PasswordStrengthValidator {
    public static validate(control: AbstractControl): ValidationErrors {
        const hasLowercase = new RegExp('^(?=.*[a-z])');
        const hasUppercase = new RegExp('^(?=.*[A-Z])');
        const hasDigit = new RegExp('^(?=.*[0-9])');
        const hasAtLeastSixCharacters = new RegExp('^(?=.{6,})');

        if (!control.pristine) {
            control.setErrors({
                noLower: !hasLowercase.test(control.value),
                noUpper: !hasUppercase.test(control.value),
                noDigit: !hasDigit.test(control.value),
                notEnoughCharacters: !hasAtLeastSixCharacters.test(control.value)
            });

            if (hasLowercase.test(control.value) && hasUppercase.test(control.value) &&
                hasDigit.test(control.value) && hasAtLeastSixCharacters.test(control.value)) {
                control.setErrors(undefined);
            }
        }

        return control.errors;
    }
}
